import { existsGtmId, GTM_ID, GTM_PARAMS } from '@/lib/googleTagManager/gtm'

export const GTMNoscript = () => {
  return existsGtmId ? (
    <noscript
      dangerouslySetInnerHTML={{
        // iframe は "/>" では閉じられず、後続の HTML が iframe の中身として読まれるため閉じタグを書く
        __html: `
                <iframe
                  src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}${
          GTM_PARAMS ? `&${GTM_PARAMS}` : ''
        }"
                  height="0"
                  width="0"
                  style="display:none;visibility:hidden"
                ></iframe>`,
      }}
    />
  ) : null
}
